/**
 * Guardas puras do fluxo de "Importar configurações" (wizard Criar Escala).
 *
 * Extraídas de `CreateSchedule.vue` para serem testáveis sem montar o
 * componente inteiro (que arrasta store, header, feature flags etc.).
 */

/** Subconjunto de `HealthUnitSelectOption` (useHealthUnitStore) que a guarda precisa. */
export interface ImportableUnitOption {
  value: number
}

/** Subconjunto de `ScheduleStep1` (useCreateScheduleStore) que a guarda precisa. */
export interface ImportedUnitStep {
  healthUnitId: number | null
}

/**
 * O import duplica a unidade da escala de origem, mas o usuário pode ter acesso de
 * LEITURA a uma escala numa unidade em que não pode CRIAR — os escopos são diferentes.
 * Nesse caso a unidade não aparece no select e salvar falharia no backend, então é
 * melhor descartá-la e pedir que o usuário escolha.
 *
 * Só decide quando as opções já estão carregadas: com a lista vazia não há como saber
 * se a unidade está disponível ou não, e descartar a unidade importada por esse motivo
 * seria pior (o chamador deve garantir a lista carregada ANTES de chamar esta função —
 * ver `CreateSchedule.vue`, `onMounted` e `handleImportSchedule`).
 *
 * Função pura: não muta `step`, apenas retorna a decisão. O chamador aplica a limpeza
 * (`healthUnitId`/`healthUnitName`) e decide a mensagem de feedback.
 *
 * @returns `true` se a unidade importada deve ser descartada.
 */
export function dropImportedUnitIfUnavailable(
  options: ImportableUnitOption[],
  step: ImportedUnitStep
): boolean {
  if (!options.length || !step.healthUnitId) return false

  const isAvailable = options.some((unit) => unit.value === step.healthUnitId)
  return !isAvailable
}
